import { getGroupPermissionFactory, PermissionEnum } from '../../../../common';
import { StatesPermissions } from './states.permissions';

export class CityDistrictsPermissions {
    static GroupName = `${StatesPermissions.GroupName}.Districts`;

    static getPermissions = getGroupPermissionFactory(CityDistrictsPermissions.GroupName);

    static Permissions = {
        ReadAll: CityDistrictsPermissions.getPermissions(PermissionEnum.READ_ALL),
    };
}
